export default __webpack_public_path__ + "static/signature-m5-ccb9fd3149d0e4d00ff955b66b189f13.png";